<div class="upsell-faq p-1">
  <div class="upsell-faq__container mx-auto">
    <div class="upsell-faq__wrapper p-4 w-full">
      <div class="upsell-faq__title text-3xl text-bhmd-blue mt-2" [innerHTML]="upsellFaqTitle"></div>
      <div class="upsell-faq__questions"> 
        <div *ngFor="let item of upsellFaqContent; trackBy: trackByFn" class="upsell-faq__item mb-6">
          <p class="upsell-faq__question text-lg font-bold uppercase" [innerHTML]="item.question"></p>
          <p class="upsell-faq__answer" [innerHTML]="item.answer"></p>
        </div>
      </div>
    </div>
  </div>
</div>